<div
  *ngIf="search.trim().length == 0 || cash.remark.includes(search)"
  class="cash-container bg-light border border-light rounded-left d-flex justify-content-between h-auto mb-2 rounded"
  (click)="selectCash($event)"
  role="button"
>
  <p
    class="currency pt-3"
    [ngClass]="cash.in == 1 ? 'cash-in' : 'cash-out'"
    style="text-align: center"
  >
    {{ cash.amount | currency : "TND" }}
  </p>
  <p class="remark pt-3 text-center">
    {{ cash.remark }}
  </p>
  <p class="date pt-3 text-center">
    {{ cash.date | date }}
  </p>

  <p class="balance pt-3 text-center">
    {{ cash.balance | currency : "TND" }}
  </p>
  <p class="delete text-danger pt-3" (click)="deleteCash($event)">X</p>
</div>

<div id="modal" #modal></div>
